import React, { PropsWithChildren } from "react";

import { useDebouncedPageTracker } from "../utils/googleAnalytics";

/** Sends a debounced "page" track event when location changes */
export const TrackPages: React.FC<PropsWithChildren> = ({ children }) => {
  useDebouncedPageTracker();
  return <>{children}</>;
};
